import { render } from "./TableCommon.vue?vue&type=template&id=3063aca4&scoped=true"
import script from "./TableCommon.vue?vue&type=script&lang=js"
export * from "./TableCommon.vue?vue&type=script&lang=js"

import "./TableCommon.vue?vue&type=style&index=0&id=3063aca4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3063aca4"]])

export default __exports__